module.exports = fox._r("images/dashboard-sprite.png", __webpack_public_path__ + "_/_/_/common/frame/images/dashboard-sprite.png");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/images/dashboard-sprite.png
// module id = 25
// module chunks = 2